import * as angular from 'angular';


export class AncillariesAllianzFusionTransformer {
    constructor (
        private CurrencyService: CurrencyService
    ) {}

    generateAllianzFusionInfo = (insuranceInfo: any, transformedInsuranceInfo: any) => {
        transformedInsuranceInfo.insuranceInfo = insuranceInfo.locations[0];
        transformedInsuranceInfo.insuranceInfo.countriesRequiredInfo = insuranceInfo.countriesRequiredInfo;
        transformedInsuranceInfo.insuranceInfo.countriesList = [];
        transformedInsuranceInfo.insuranceInfo.priceZero = null;
        transformedInsuranceInfo.insuranceInfo.conditionsUri = '';
        transformedInsuranceInfo.insuranceInfo.id = null;
        transformedInsuranceInfo.insuranceInfo.issueCountry = '';
        transformedInsuranceInfo.insuranceInfo.consent = '';
        transformedInsuranceInfo.insuranceInfo.priceFrom = this.allianzFusionPriceFrom (insuranceInfo, transformedInsuranceInfo.currency);
    };

    allianzFusionPriceFrom = (allianzFusionInfo: any, currency: any) => {
        let priceFrom = 0;
        for (const product of allianzFusionInfo.products) {
            if ((priceFrom === 0 || priceFrom > product.totalPrice) && product.totalPrice !== 0) {
                priceFrom = product.totalPrice;
            }
        }
        return this.CurrencyService.formatPrice(currency, priceFrom, true, false);
    };
}

AncillariesAllianzFusionTransformer.$inject = ['CurrencyService'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesAllianzFusionTransformer', AncillariesAllianzFusionTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesAllianzFusionTransformer', AncillariesAllianzFusionTransformer);
}
